// extracted by mini-css-extract-plugin
export default {"container":"Wait_container__u9n5o","list":"Wait_list__ZpWni","num":"Wait_num__XrTS1","btn":"Wait_btn__-m6+o"};